<template>
  <keep-alive>
    <top-navbar :currentRoute="$route" :filter="false"></top-navbar>
  </keep-alive>

  <section class="container-content orders-container-content">
    <transition name="fade">
      <section v-if="!isReady" class="absolute-center-block">
        <div class="container-loading">
          <span class="loader loader-default loader-dark"></span>
        </div>
      </section>
    </transition>

    <transition name="fade">
      <div v-if="kpError != ''" class="error-message mt-10">
        {{ kpError }}
      </div>
      <div v-else-if="isReady">

        <section class="container-table">

          <table-component
            :currUserID="currUserID"
            :allHeaders="allHeaders"
            :headersDefault="headersDefault"
            :dataObject="data"
            :defaultData="defaultData"
            :type="typePage"
            :showLeftColumn="false"
            @sort-table="selectSortField"
            @open-page="openKP"
            @copy-page="createOrderOnKP"
          ></table-component>

        </section>

      </div>
    </transition>
  </section>
</template>

<script>
import TopNavbar from "../components/TopNavbar.vue";
import TableComponent from "../components/TableComponent.vue";
import GlobalRequest from "@/plugins/globalRequest";

export default {
  name: 'KPPage',
  components: {
    TopNavbar,
    TableComponent
  },
  data() {
    return {
      typePage: 'kp',
      isReady: false,
      headersDefault: {
        id: "ID", 
        proposalNumber: "№ КП", 
        deal: "Наименование проекта", 
        validFrom: "Дата КП", 
        validTo: "Действует до", 
        regions: "Регион доставки"
      },
      allHeaders: {
        id: "ID", 
        proposalNumber: "№ КП", 
        deal: "Наименование проекта", 
        validFrom: "Дата КП", 
        validTo: "Действует до", 
        regions: "Регион доставки"
      },
      data: [],
      defaultData: [],
      currUserID: "",
      kpError: "",
    }
  },
  mounted() {

    if(localStorage.getItem('userID') != undefined && localStorage.getItem('userID') != '') {
      this.currUserID = localStorage.getItem('userID')
    }

    console.log(this.$route)
    this.init();
  },
  watch: {
    activeTab() {
      this.init()
    }
  },
  methods: {

    // Инициализация
    async init() {
      this.isReady = false
      await this.getData()

      // клон
      this.defaultData = JSON.parse(JSON.stringify(this.data))
      this.isReady = true
    },

    async getData() {
      let res = await GlobalRequest.request("/proposal/list", "GET")
      console.log(res)
      if(res.success) {
        this.kpError = ""
        this.data = res.data.proposalsList
        
        // регионы в строку пока что
        this.data.forEach(item => {
          item.validFrom = this.formatDate(item.validFrom)
          item.validTo = this.formatDate(item.validTo)

          if (item.regions.length > 0) {
            item.regions = item.regions.map(region => region.name).join(', ');
          } else {
            item.regions = '';
          }
        });

      }
      else {
        this.data = []
        this.kpError = "Ошибка получения данных"
      }
    },

    // Выбор поля для сортировки
    selectSortField(newDataObj) {
      this.data = newDataObj
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    },

    // Открыть
    openKP(id) {
      this.$router.push({
        path: '/kp/detail',
        query: { id: id},
      });
    },

    // Создать заказ на основании
    createOrderOnKP(id) {
      this.$router.push({
        path: '/order/create',
        query: { idKP: id},
      });
    },
  }
}
</script>
